// ============================================================================
// Types partagés de la feature Trend.
// ============================================================================

/**
 * Seuils locaux du tableau Trend — même principe que `FilterValues` des niches
 * d'une analyse : ils masquent des lignes, ils ne changent ni le classement
 * serveur ni les rangs affichés.
 */
export interface TrendFilterValues {
  caPerMonthMin?: number;
  caPerMonthMax?: number;
  soldPctMin?: number;
  soldPctMax?: number;
  salesPerDayMin?: number;
  salesPerDayMax?: number;
  avgPriceMin?: number;
  avgPriceMax?: number;
  timeToSellMin?: number;
  timeToSellMax?: number;
  productCountMin?: number;
  productCountMax?: number;
  growthMin?: number;
  growthMax?: number;
}

/** Métriques d'une niche telles que renvoyées par getTrendList. */
interface TrendMetricsLike {
  caPerMonth?: number | null;
  soldPct?: number | null;
  salesPerDay?: number | null;
  avgPrice?: number | null;
  timeToSellHours?: number | null;
  productCount: number;
  growthPct?: number | null;
}

// Une métrique ABSENTE (null) ne fait pas tomber la ligne — même convention
// que le filtrage des niches d'une analyse.
const inRange = (value: number | null | undefined, min: number | undefined, max: number | undefined): boolean => {
  if (value == null) return true;
  if (min !== undefined && value < min) return false;
  if (max !== undefined && value > max) return false;
  return true;
};

/** Vrai si la niche respecte toutes les bornes posées. */
export const matchesTrendFilters = (metrics: TrendMetricsLike, filters: TrendFilterValues): boolean =>
  inRange(metrics.caPerMonth, filters.caPerMonthMin, filters.caPerMonthMax) &&
  inRange(metrics.soldPct, filters.soldPctMin, filters.soldPctMax) &&
  inRange(metrics.salesPerDay, filters.salesPerDayMin, filters.salesPerDayMax) &&
  inRange(metrics.avgPrice, filters.avgPriceMin, filters.avgPriceMax) &&
  inRange(metrics.timeToSellHours, filters.timeToSellMin, filters.timeToSellMax) &&
  inRange(metrics.productCount, filters.productCountMin, filters.productCountMax) &&
  inRange(metrics.growthPct, filters.growthMin, filters.growthMax);
